import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PartnerCard = ({ name, type, description, image }) => {
  return (
    <div className="bg-gray-900 rounded-xl overflow-hidden border border-gray-800 transition-all duration-300 hover:shadow-xl hover:shadow-purple-500/10 hover:border-purple-500/50">
      <div className="h-40 bg-gray-800 relative overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-full h-full bg-gray-700/30 flex items-center justify-center">
          <div className="w-full h-40 bg-gray-700/30 flex items-center justify-center">
        {image ? (
          <img src={image} alt={`${name} logo`} className="partner-logo" />
        ) : (
          <span className="text-2xl font-bold text-gray-400">{name}</span>
        )}
      </div>
            </div>
        </div>
      </div>
      <div className="p-6">
        <div className="mb-2">
          <span className="px-3 py-1 bg-purple-900/30 text-purple-400 rounded-full text-xs font-medium">
            {type}
          </span>
        </div>
        <h3 className="text-xl font-bold text-white mb-3">{name}</h3>
        <p className="text-gray-300">{description}</p>
      </div>
    </div>
  );
};

const Partners = () => {
  return (
    <div className="min-h-screen flex flex-col bg-black text-white">
      <Navbar />
      <main className="flex-grow py-10 page-transition">
        <div className="container-custom">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 via-pink-500 to-indigo-400">
              Our Partners
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              We're building clinical validation partnerships with healthcare institutions across Nigeria and Kenya to bring AI-assisted diagnostics into real clinical workflows.
            </p>
          </div>

          {/* Partners by Category */}
          <div className="mb-20">
            <h2 className="text-3xl font-bold mb-10">Clinical Validation Partners</h2>
            
            <div className="grid md:grid-cols-3 gap-8">
              <PartnerCard 
                name="JaliMindCare, Kenya"
                type="Telehealth Provider"
                description="One of Kenya's leading telehealth platform partnering with us to provide AI diagnostics & telehealth solutions in Africa."
                image="/images/jalimindcare-logo.jpeg"
              />
              
              <PartnerCard 
                name="Lagos University Teaching Hospital"
                type="Healthcare Institution"
                description="Nigeria's premier teaching hospital working with us to train the next generation of physicians on AI-assisted diagnostics while improving patient care."
                image="/images/luth-logo.png"
              />
              
              <PartnerCard 
                name="St. Dominic Savio Hospital, Nigeria"
                type="Hospital & Laboratory"
                description="Collaborating to establish best practices and clinical guidelines for the implementation of AI in diagnostic workflows across African healthcare systems."
                image="/images/st-dominic-savio-logo.png"
              />
              
            </div>
          </div>

          {/* Partnership Tiers */}
          <div className="mb-20">
            <h2 className="text-3xl font-bold mb-10 text-center">Partnership Opportunities</h2>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-gradient-to-br from-gray-900 to-gray-900/80 rounded-xl p-8 border border-gray-800 flex flex-col">
                <h3 className="text-2xl font-bold mb-4 text-white">Clinical Partner</h3>
                <div className="mb-6 text-gray-300 flex-grow">
                  <p className="mb-4">
                    For healthcare facilities looking to implement our AI diagnostic solutions into their existing workflows.
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-purple-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span>Implementation support and training</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-purple-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span>Customization for your specific needs</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-purple-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span>Ongoing technical support</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-purple-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span>Regular AI model updates</span>
                    </li>
                  </ul>
                </div>
                <Link 
                  to="/contact" 
                  className="block w-full py-3 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white rounded-lg font-medium text-center mt-4"
                >
                  Become a Clinical Partner
                </Link>
              </div>
              
              <div className="bg-gradient-to-br from-gray-900 to-gray-900/80 rounded-xl p-8 border border-purple-500/30 flex flex-col relative shadow-xl shadow-purple-500/10">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white text-sm font-medium px-4 py-1 rounded-full">
                  Most Popular
                </div>
                <h3 className="text-2xl font-bold mb-4 text-white">Strategic Partner</h3>
                <div className="mb-6 text-gray-300 flex-grow">
                  <p className="mb-4">
                    For organizations looking to co-develop solutions and reach underserved communities.
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-purple-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span>All Clinical Partner benefits</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-purple-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span>Joint implementation programs</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-purple-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span>Co-branded solutions</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-purple-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span>Shared impact measurement</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-purple-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span>Priority feature development</span>
                    </li>
                  </ul>
                </div>
                <Link 
                  to="/contact" 
                  className="block w-full py-3 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white rounded-lg font-medium text-center mt-4"
                >
                  Become a Strategic Partner
                </Link>
              </div>
              
              <div className="bg-gradient-to-br from-gray-900 to-gray-900/80 rounded-xl p-8 border border-gray-800 flex flex-col">
                <h3 className="text-2xl font-bold mb-4 text-white">Research Partner</h3>
                <div className="mb-6 text-gray-300 flex-grow">
                  <p className="mb-4">
                    For academic and research institutions looking to improve healthcare AI for African populations.
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-purple-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span>Data sharing agreements</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-purple-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span>Joint research programs</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-purple-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span>Publication collaboration</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-5 h-5 text-purple-400 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span>Academic training programs</span>
                    </li>
                  </ul>
                </div>
                <Link 
                  to="/contact" 
                  className="block w-full py-3 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white rounded-lg font-medium text-center mt-4"
                >
                  Become a Research Partner
                </Link>
              </div>
            </div>
          </div>
          
          {/* CTA Section */}
          <div className="bg-gradient-to-r from-purple-900/50 to-indigo-900/50 rounded-2xl p-10 text-center border border-purple-500/30">
            <h2 className="text-3xl font-bold mb-4">Interested in Partnering With Us?</h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              Join our mission to transform healthcare across Africa through innovative AI diagnostics. Let's explore how we can work together.
            </p>
            <Link 
              to="/contact" 
              className="px-8 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white rounded-lg font-medium inline-block"
            >
              Contact Our Partnership Team
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Partners;